import openPersistentTaskPaneAddinCommand from '../../entryPointOperations/openPersistentTaskPaneAddinCommand';
import updatePersistentTaskPaneError from 'owa-addins-store/lib/actions/updatePersistentTaskPaneError';
import { getMode } from '../NavigationConditions';
import { sendItemUpdatedEvent } from '../SendItemEvent';
import { setPreviousNavigationState } from '../PreviousNavigationState';
import {
    getTaskPaneRunningInstance,
    TaskPaneErrorType,
    TaskPaneType,
    updatePersistentTaskPaneHostItem,
} from 'owa-addins-store';

export default function sendItemUpdateToAddinNavigationOperation(hostItemIndex: string) {
    resetErrorStateOnTaskpane();

    if (getTaskPaneRunningInstance(TaskPaneType.Persistent)) {
        updatePersistentTaskPaneHostItem(hostItemIndex);
        sendItemUpdatedEvent(hostItemIndex);
    } else {
        openPersistentTaskPaneAddinCommand(hostItemIndex);
    }

    setPreviousNavigationState({
        hostItemIndex: hostItemIndex,
        mode: getMode(hostItemIndex),
        isNullSent: false,
    });
}

function resetErrorStateOnTaskpane() {
    updatePersistentTaskPaneError(TaskPaneErrorType.None);
}
